export default __webpack_public_path__ + "static/media/unionLogoBG.f3fffc26.svg";